import { useCallback, useEffect, useState } from 'react'
import type { ChangeEvent } from 'react'

const NO_SELECTION: Array<string> = []

export function usePropertyOptionalBundleSelection(rateId: string) {
  const [selectedBundleIds, setSelectedBundleIds] = useState<Array<string>>(NO_SELECTION)

  // Switching rate re-renders this component tree rather than remounting it, so the previous rate's
  // selection would otherwise stick around against bundles that no longer exist.
  useEffect(() => {
    setSelectedBundleIds(NO_SELECTION)
  }, [rateId])

  const onToggleBundle = useCallback((bundleId: string, event: ChangeEvent<HTMLInputElement>) => {
    const checked = event.currentTarget.checked
    setSelectedBundleIds((previous) => {
      if (checked) return previous.includes(bundleId) ? previous : [...previous, bundleId]
      return previous.includes(bundleId) ? previous.filter(id => id !== bundleId) : previous
    })
  }, [])

  return {
    selectedBundleIds,
    onToggleBundle,
  }
}

export default usePropertyOptionalBundleSelection
